module.exports = __webpack_public_path__ + "static/media/R-300HD.be9fec97.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/R-300HD.png
// module id = 2104
// module chunks = 0